module.exports = __webpack_public_path__ + "img/10_DSC7941-min.3a9d66ab.jpg";